/* screens/settings/billingCrosslink.js — какую подсказку-перекрёстку показать между
   текущим тарифом и списком тарифов (личная вкладка ↔ вкладка «Заведения»).

   Подсказка заведена как воронка: ресторан приходил на личную вкладку, покупал
   ассистента и ждал аналитику. Поэтому на личной вкладке сказано «аналитика — во
   вкладке „Заведения“», а на бизнес-вкладке «здесь ассистент, аналитика кассы и команда».

   Для команды, у которой тариф ЗАКРЫЛ «Аналитику» (workspace.sections.analytics ===
   false, договор Family Garden), обе фразы — обещание раздела, которого у неё нет.
   Тогда показываем вариант без аналитики. Правило закрытия — то же, что в меню
   (lib/planSections.js): только булев false; без sections — как раньше.

   Чистая логика без React — покрыта vitest. */

import { SECTION_ANALYTICS, isSectionEnabled, userSeesBusinessAnalytics } from '../../lib/planSections.js';

/**
 * scope 'personal' — личная вкладка: указатель на аналитику уместен, если у пользователя
 *   нет ни одного заведения (воронка «заведите заведение») или хотя бы в одном из его
 *   заведений аналитика открыта. Все заведения закрыты тарифом → вариант без аналитики.
 * scope 'business' — вкладка конкретного заведения: смотрим на ЕГО тариф.
 *
 * Возвращает 'personal-analytics' | 'personal-plain' | 'business-analytics' | 'business-plain'.
 */
export function crosslinkVariant(scope, { workspace = null, businessWorkspaces = [] } = {}) {
  if (scope === 'personal') {
    const list = (businessWorkspaces || []).filter(Boolean).map((w) => ({ kind: 'business', ...w }));
    return userSeesBusinessAnalytics(list) ? 'personal-analytics' : 'personal-plain';
  }
  return isSectionEnabled(workspace, SECTION_ANALYTICS) ? 'business-analytics' : 'business-plain';
}
